import axios from "axios";

export function getNoticeTypeList(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "NoticeType/getlist", config);
}

export function postNoticeType(data) {
  return axios.post(process.env.VUE_APP_API_URL + "NoticeType/add", data);
}

export function updateNoticeType(data) {
  return axios.put(process.env.VUE_APP_API_URL + "NoticeType/update", data);
}

export function deleteNoticeType(noticeTypeId) {
  const config = {
    params: {
      noticeTypeId: noticeTypeId,
    },
  };

  return axios.delete(
    process.env.VUE_APP_API_URL + "NoticeType/deleted",
    config
  );
}
